export default __webpack_public_path__ + "static/media/image13.11104d46.jfif";